const $counters = document.querySelectorAll('[data-count-up]');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

const countDuration = 1800;
const numberPattern = /\d+(?:[\s\u00a0\u202f.,]\d+)*/;

// Spaces group thousands, a comma is a decimal separator (fr-CA), and a dot is a decimal
// separator unless it is followed by exactly three digits
function parseNumber(text) {
    const match = text.match(numberPattern);
    if (!match) {
        return null;
    }
    const raw = match[0];
    const separators = raw.match(/[^\d]/g) || [];
    const last = separators[separators.length - 1];
    const lastGroup = raw.split(/[^\d]/).pop();
    const hasDecimals = last === ',' || (last === '.' && lastGroup.length !== 3);
    const decimals = hasDecimals ? lastGroup.length : 0;
    const integerPart = hasDecimals ? raw.slice(0, raw.length - decimals - 1) : raw;
    const groupSeparators = hasDecimals ? separators.slice(0, -1) : separators;

    return {
        text,
        prefix: text.slice(0, match.index),
        suffix: text.slice(match.index + raw.length),
        value: parseFloat(`${integerPart.replace(/[^\d]/g, '')}.${hasDecimals ? lastGroup : 0}`),
        decimals,
        decimalSeparator: hasDecimals ? last : '',
        groupSeparator: groupSeparators[0] || '',
    };
}

function formatNumber(value, {
    decimals, decimalSeparator, groupSeparator,
}) {
    const [integer, fraction] = value.toFixed(decimals).split('.');
    const grouped = groupSeparator
        ? integer.replace(/\B(?=(\d{3})+(?!\d))/g, groupSeparator)
        : integer;
    return fraction ? `${grouped}${decimalSeparator}${fraction}` : grouped;
}

const renderNumber = (number, value) => `${number.prefix}${formatNumber(value, number)}${number.suffix}`;

const easeOutCubic = (progress) => 1 - (1 - progress) ** 3;

// Share of the reveal animation to wait for before counting, so the count stays visible
const revealProgress = 0.25;

// Time left before the reveal transition of an ancestor reaches revealProgress,
// read from the running CSS transition itself
function getRevealWait($reveal) {
    const transition = $reveal.getAnimations()
        .find((animation) => animation.transitionProperty === 'opacity');
    if (!transition) {
        return 0;
    }
    const { delay, duration } = transition.effect.getTiming();
    return Math.max(delay + duration * revealProgress - transition.currentTime, 0);
}

// The reveal may not have started yet (its observer can fire after this one)
function whenRevealed($counter, callback) {
    const $reveal = $counter.closest('.is-reveal-ready');

    if (!$reveal) {
        callback();
    } else if ($reveal.classList.contains('is-revealed')) {
        window.setTimeout(callback, getRevealWait($reveal));
    } else {
        const onTransitionRun = (event) => {
            if (event.target === $reveal && event.propertyName === 'opacity') {
                $reveal.removeEventListener('transitionrun', onTransitionRun);
                window.setTimeout(callback, getRevealWait($reveal));
            }
        };
        $reveal.addEventListener('transitionrun', onTransitionRun);
    }
}

function countUp($counter, number) {
    let startTime = null;

    function step(time) {
        if (startTime === null) {
            startTime = time;
        }
        const progress = Math.min((time - startTime) / countDuration, 1);

        if (progress < 1) {
            $counter.replaceChildren(renderNumber(number, number.value * easeOutCubic(progress)));
            window.requestAnimationFrame(step);
        } else {
            $counter.replaceChildren(number.text);
        }
    }

    whenRevealed($counter, () => window.requestAnimationFrame(step));
}

if ($counters.length && !reducedMotion.matches) {
    const numbers = new Map();

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                countUp(entry.target, numbers.get(entry.target));
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.6 });

    $counters.forEach(($counter) => {
        const number = parseNumber($counter.textContent.trim());

        if (number && number.value > 0) {
            numbers.set($counter, number);
            $counter.replaceChildren(renderNumber(number, 0));
            observer.observe($counter);
        }
    });
}
